<div class="buttons">
  <button type="button" class="btn btn-lg" (click)="toggleMenu()">
    <fa-icon [icon]="faBars"></fa-icon>
  </button>
  <button type="button" class="btn btn-lg" (click)="toggleMapOptions()">
    <fa-icon [icon]="faEye"></fa-icon>
  </button>
  <button type="button" class="btn btn-lg" (click)="toggleUserOptions()">
    <fa-icon [icon]="faUser"></fa-icon>
  </button>
</div>
<ng-container *ngIf="menuOpen">
  <mat-card class="menu">
    <button mat-icon-button class="close-button bg-transparent" (click)="toggleMenu()">
      <mat-icon aria-hidden="false">close</mat-icon>
    </button>
    <button type="button" class="btn btn-light" (click)="openDownloadPopup()">Letöltés</button>
    <button
      type="button"
      class="btn btn-light"
      [disabled]="!isLoggedIn"
      (click)="openAircraftPopup()"
    >
      Légijárművek
    </button>
    <button
      type="button"
      class="btn btn-light"
      [disabled]="!isLoggedIn"
      (click)="openGroupsPopup()"
    >
      Csoport
    </button>
    <button
      type="button"
      class="btn btn-light"
      [disabled]="!isLoggedIn"
      (click)="openMessagesPopup()"
    >
      Üzenet
    </button>
    <button type="button" class="btn btn-light" (click)="toggleContact()">Kapcsolat</button>
    <div class="contact flex-column center mb-2" *ngIf="contactOpen">
      <div>SZEMP AIR Kft.</div>
      <div><a href="https://www.szempair.hu/" target="_blank" >www.szempair.hu</a></div>
      <div>Székhely: 6724, Szeged</div>
      <div>Kossuth Lajos sgt 43. mfszt 5.</div>
    </div>
  </mat-card>
</ng-container>
<ng-container *ngIf="mapOptionsOpen">
  <mat-card class="menu">
    <button mat-icon-button class="close-button bg-transparent" (click)="toggleMapOptions()">
      <mat-icon aria-hidden="false">close</mat-icon>
    </button>
    <button type="button" (click)="onEyeElementClick('map')" class="btn btn-light">
      Térkép
    </button>
    <app-map-list *ngIf="eyeIconState === 'map'"></app-map-list>
    <button type="button" (click)="onEyeElementClick('vehicles')" class="btn btn-light">
      Légijárművek
    </button>
    <app-vehicles *ngIf="eyeIconState === 'vehicles'"></app-vehicles>
    <button type="button" (click)="onEyeElementClick('antenna')" class="btn btn-light">
      Antennák
    </button>
    <app-antennas *ngIf="eyeIconState === 'antenna'"></app-antennas>
    <button type="button" (click)="onEyeElementClick('following')" class="btn btn-light">
      Követés
    </button>
    <app-following *ngIf="eyeIconState === 'following'"></app-following>
  </mat-card>
</ng-container>

<ng-container *ngIf="userOptionsOpen">
  <mat-card class="menu">
    <button mat-icon-button class="close-button bg-transparent" (click)="toggleUserOptions()">
      <mat-icon aria-hidden="false">close</mat-icon>
    </button>
    <button type="button" class="btn btn-light" *ngIf="!isLoggedIn" (click)="openLoginPopup()">
      Bejelentkezés
    </button>
    <button type="button" class="btn btn-light" *ngIf="isLoggedIn" (click)="logout()">
      Kijelentkezés
    </button>
    <button type="button" class="btn btn-light" [disabled]="!isLoggedIn">Profil</button>
    <button type="button" class="btn btn-light">Beállítások</button>
  </mat-card>
</ng-container>
